/* app/js/src/components/publishing-status/publishing-toolbar/publishing-toolbar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
@keyframes cs-pub-catalog-overlay-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.publishing-toolbar {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  padding: 0;
}
.publishing-toolbar__filters-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  gap: 12px;
  padding-bottom: 0;
}
.publishing-toolbar__start-new {
  flex-shrink: 0;
  box-sizing: border-box;
  height: 36px;
  min-height: 36px;
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background-color: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}
.publishing-toolbar__start-new:focus {
  outline: none;
  box-shadow: none;
}
.publishing-toolbar__start-new:hover:not(:disabled) {
  background-color: rgb(41, 170, 229);
}
.publishing-toolbar__search-wrapper {
  position: relative;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  box-sizing: border-box;
  height: 36px;
  min-height: 36px;
  min-width: 280px;
  max-width: 400px;
}
.publishing-toolbar__search-wrapper ichannel-input {
  flex: 1;
  height: 100%;
}
.publishing-toolbar__search-wrapper ::ng-deep ichannel-input > div.rowInput,
.publishing-toolbar__search-wrapper ::ng-deep ichannel-input > div {
  margin-bottom: 0;
  height: 100%;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}
.publishing-toolbar__search-wrapper ::ng-deep input {
  box-sizing: border-box;
  height: 36px;
  min-height: 36px;
  line-height: normal;
}
.publishing-toolbar__clear {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.publishing-toolbar__clear:hover {
  color: rgba(0, 0, 0, 0.85);
}
.publishing-toolbar__status-dropdown,
.publishing-toolbar__date-range {
  box-sizing: border-box;
  height: 36px;
  min-height: 36px;
  flex-shrink: 0;
  min-width: 140px;
}
.publishing-toolbar__batch-actions {
  margin-left: auto;
  flex-shrink: 0;
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 8px;
}
.publishing-toolbar__delete,
.publishing-toolbar__import-to-mam {
  box-sizing: border-box;
  height: 36px;
  min-height: 36px;
  flex-shrink: 0;
  cursor: pointer;
  display: inline-flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 8px;
  padding: 0 16px 0 9px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  color: rgba(0, 0, 0, 0.54);
  background: transparent;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
}
.publishing-toolbar__delete svg,
.publishing-toolbar__import-to-mam svg {
  flex-shrink: 0;
  fill: currentColor;
}
.publishing-toolbar__delete.button-disabled,
.publishing-toolbar__import-to-mam.button-disabled {
  cursor: not-allowed;
  background: rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
/*# sourceMappingURL=publishing-toolbar.component.css.map */
